/*eslint-disable*/ module.exports = {
  messages: {
    Active: 'Activ',
    Add: 'Adauga',
    'Add Beer Selection': 'Adauga selectia de bere',
    'Add Beer Servings': 'Adauga cantitatea berilor',
    'Add New dish': 'Adauga preparat nou',
    'Add New item': 'Adauga articol nou',
    'Add Picture': 'Adauga poza',
    'Add QR code': 'Adauga cod QR',
    'Add category or element': 'Adauga categorie sau element',
    'Add dish': 'Adauga preparat',
    'Add meal': 'Adauga mancare',
    'Add new menu': 'Adauga meniu nou',
    'Add other': 'Adauga altele',
    'Add soup': 'Adauga supa',
    'Add Star Of The Crafters': 'Add The Brewers Star - BW',
    'Add Colored Star Of The Crafters': 'Add The Brewers Star - color',
    'After creating a category, you can add dishes.':
      'Dupa crearea unei categorii poti adauga un preparat nou.',
    'Alcohol Content': 'Continut de alcool',
    All: 'Toate',
    'All languages': 'Adauga limba',
    Allergens: 'Alergeni',
    Amount: 'Cantitate',
    'Are you sure you want to delete this daily menu?':
      'Esti sigur ca vrei sa stergi acest meniu al zilei?',
    'Are you sure you want to delete this menu?':
      'Esti sigur ca vrei sa stergi acest meniu?',
    'Available only for A4 size': 'Disponibil numai in format A4',
    'Back to Daily Menu': 'Înapoi',
    'Back to Food Menu': 'Înapoi',
    'Beer Selection': 'Selectie bere',
    'Beer Type': 'Tip de bere',
    'Beer servings': 'Cantitate bere',
    Bottom: 'Jos',
    'Brand elements': 'Elemente de brand',
    "Can't upload image": 'Nu pot incarca poza',
    Cancel: 'Anuleaza',
    Categories: 'Categorii',
    'Click to select a date': 'Click pentru selectie data',
    Close: 'Inchide',
    Color: 'Culoare',
    Continue: 'Continua',
    'Copy menu': 'Copiaza meniu',
    'Country Of Origin': 'Tara de origine',
    'Create Text Block': 'Creeaza casuta de text',
    Currency: 'Moneda',
    'Daily Menu': 'Meniul zilei',
    'Daily menu': 'Meniul zilei',
    Data: 'Data',
    'Data & Elements': 'Data & elemente',
    Delete: 'Sterge',
    'Delete menu': 'Sterge meniu',
    'Delete page break': 'Sterge intreruperea de pagina',
    Description: 'Descriere',
    'Description (Optional)': 'Descriere (Optional)',
    Desserts: 'Deserturi',
    Designs: 'Designs',
    Displays: 'Afisari',
    'Double Image Block': 'Blocare poza dubla',
    Duplicate: 'Duplicat',
    'Duplicate menu': 'meniu duplicat',
    Edit: 'Editeaza',
    'Edit Beer Servings': 'Editeaza cantitate bere',
    'Edit Picture': 'Editeaza poza',
    'Edit QR code': 'Editeaza cod QR',
    'Edit Star Of The Crafters': 'Edit The Brewers Star - BW',
    'Edit Colored Star Of The Crafters': 'Edit The Brewers Star - color',
    'Edit Text Block': 'Editeaza casuta Text',
    'Edit dish': 'Editeaza preparat',
    Elements: 'Elemente',
    Email: 'Email',
    'Error!': 'Eroare!',
    Export: 'Exporta',
    'Export XML': 'Exporta ca XML',
    'Export PDF': 'Exporta ca PDF',
    'Export as JPG': 'Exporta ca JPG',
    Fermentation: 'Fermentare',
    'Fill in your contact information and we will reach back to you:':
      'Completați informațiile dvs. de contact și vă vom contacta:',
    'Food Combinations': 'Combinare mancare',
    'Food cards & Specials': 'Oferte mancare & speciale',
    'Food image': 'Poza mancare',
    'Generate QR code': 'Genereaza cod QR',
    Grid: 'Grila',
    'Hover over the tab area to see options for adding categories and elements.':
      'Plaseaza cursorul peste zona dorita pentru a vedea opțiunile pentru adăugarea de categorii și elemente.',
    Inline: 'Pe linie',
    Language: 'Limba',
    List: 'Lista',
    'Log in': 'Logare',
    Logo: 'Logo',
    'Logo (Not available)': 'Logo (Indisponibil)',
    Logout: 'Iesire',
    Meals: 'Preparate',
    Menu: 'Meniu',
    'Move Block': 'Muta casuta',
    'Move Dish': 'Muta preparat',
    'Move Dish position': 'Muta pozitia preparatului',
    'Move after block': 'Muta dupa casuta',
    'Move after dish': 'Muta dupa preparat',
    'Move block position': 'Muta pozitia casutei',
    'Move to beginning': 'Muta la inceput',
    Name: 'Nume',
    'Name of Restaurant': 'Nume restaurant',
    'Name of category': 'Nume categorie',
    Next: 'Urmatorul',
    'No daily menus were found. Please try to change filters.':
      'Nu au fost găsite meniuri zilnice. Vă rugăm să încercați să schimbați filtrele.',
    'No menus were found. Please try to change filters.':
      'Nu au fost găsite meniuri. Vă rugăm să încercați să schimbați filtrele.',
    'Ocenění za nejlepší peči o čepované pivo':
      'Ocenění za nejlepší peči o čepované pivo',
    'One column': 'O singura coloana',
    'One column with image': 'O singura coloana cu poza',
    'Order Print': 'Comanda printare',
    Other: 'Altul',
    Others: 'Altele',
    'Page break': 'Intrerupere pagina',
    Phone: 'Telefon',
    Picture: 'Poza',
    'Vă rugăm să continuați prin autentificare':
      'Vă rugăm să continuați prin autentificare',
    Position: 'Pozitie',
    Preview: 'Previzualizare',
    Price: 'Pret',
    'Price with soup': 'Pret cu supa',
    'Price with meal': 'Pret cu mancare',
    'Price with soup and meal': 'Pret cu supa si mancare',
    Primary: 'Primar',
    'Secondary Primary': 'primar',
    Print: 'Printeaza',
    'QR code': 'Cod QR',
    'Recommend a drink': 'Recomanda o bautura',
    Remove: 'Inlatura',
    'Remove category': 'Inlatura categorie',
    'Remove dish': 'Inlatura preparat',
    'Required field': 'Camp necesar',
    Save: 'Salveaza',
    'Select allergens': 'Selecteaza alergeni',
    'Serving Temperature': 'Temperatura de servire',
    'Set to active': 'Seteaza activ',
    'Set to inactive': 'Seteaza inactiv',
    Settings: 'Setari',
    Share: 'Distribuie',
    'Share on FB': 'Distribuie pe Facebook',
    'Copy menu link': 'Copiaza link meniu',
    'Show Allergens': 'Arata alergeni',
    'Show Title Page': 'Arata titlu pagina',
    'Show info': 'Arata informatii',
    'Show name of Restaurant': 'Arata nume restaurant',
    'Show portion size': 'Arata cantitatea portiei',
    'Show text': 'Arata text',
    'Show weight / bulk / pieces': 'Afișați greutate / portie/ bucăți',
    Size: 'Marime',
    'Marime secundara': 'Marime',
    'size in cl': 'Marime in cl',
    'size in ml': 'Marime in ml',
    Soup: 'Supa',
    'Soup can be orderer separately': 'Supa se poate comanda separat',
    'Soup priced in main dish': 'Pretul supei in preparatul principal',
    Soups: 'Supe',
    Submit: 'Trimite',
    Taste: 'Gust',
    Templates: 'Sabloane',
    'Text block': 'Casuta text',
    'Tips & Tricks': 'Tips & Tricks',
    Title: 'Titlu',
    'Two columns': 'Doua coloane',
    'Two columns with image': 'Doua coloane cu poza',
    'Type or choose category': 'Scrie sau alege categorie',
    'Type or choose dish': 'Scrie sau alege preparat',
    'URL address': 'Adresa URL',
    Untitled: 'Fara titlu',
    'Upload image': 'Incarca poza',
    'We do not offer anything for this day': 'Nu sunt oferte pentru aceasta zi',
    'We do not offer:': 'Nu sunt oferte:',
    'Weight / bulk / pcs': 'Greutate / portie / buc',
    'Weight / bulk / pieces': 'Greutate / portie / bucati',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Este posibil să pierdeți unele setări de aspect prin această modificare. Vrei sa continui?',
    'Známky kvalitně načepovaného piva': 'Známky kvalitně načepovaného piva',
    add: 'adauga',
    'category/element': 'categorie/element',
    description: 'descriere',
    item: 'articol',
    language: 'limba',
    languange: 'limba',
    logo: 'logo',
    'remove page': 'Inlatura pagina',
    units: 'unitati',
    '{0}': [['0']],
    '{label}': [['eticheta']],
    'Secondary Menu': 'Meniu',
    'Secondary Other': 'Altul',
    'Logo (Not available)': 'Logo (Indisponibil)',
    "Can't upload image": 'Nu pot incarca poza',
    'Description not available': 'Descriere indisponibila',
    'Edit Beer Selection': 'Editeaza selectie bere',
    'Title is required': 'Titlul este necesar',
    'Select beers': 'Beri selectate',
    'Mandatory field': 'Camp obligatoriu',
    Image: 'poza',
    'not available': 'Indisponibil',
    'Copied successfully!': 'Copiat cu succes!',
    'Error copied!': 'Eroare copiere!',
    'Separate price for each item': 'Pret separat pentru supa si mancare',
    'Soup price is included in menu': 'Pretul supei este inclus in meniu',
    'Different price for the whole menu': 'Pret diferit pentru intreg meniu',
    'Responsibility Message': 'Mesaj de responsabilitate',
    'ID:': 'ID',
    'Please complete the first 2 steps': 'Va rugam sa completati primii 2 pasi',
    'Image generation in progress. Please wait. When the download is complete, return to the list of daily menus.':
      'Generarea imaginii este în curs. Vă rugăm să așteptați. Când descărcarea este completă, reveniți la lista de meniuri zilnice.',
    'Are you sure you want to delete this category?':
      'Esti sigur ca vrei sa stergi aceasta categorie?',
    Yes: 'Da',
    No: 'Nu',
    'Delete item': 'Sterge articol',
    'Edit element': 'Editeaza element',
    'Write a name': 'Scrie un nume',
    'Create category': 'Creeaza categorie',
    'Edit category': 'Editeaza categorie',
    'Delete category': 'Sterge categorie',
    'Choose a category': 'Alege o categorie',
    Custom: 'Personalizat',
    'Add item': 'Adauga articol',
    'Add category': 'Adauga categorie',
    'This category already exists.': 'Aceasta categorie exista deja.',
    'Something went wrong, probably your file exceeds the allowed post-processing size 10Mb. Please try again with a smaller file.':
      'Ceva nu a mers bine, probabil fișierul dvs. depășește dimensiunea de post-procesare permisă de 10Mb. Vă rugăm să încercați din nou cu un fișier mai mic.',
    'The uploaded file exceeds the maximum allowed size of 10MB. Please upload a smaller file.':
      'Fișierul încărcat depășește dimensiunea maximă permisă de 10MB. Vă rugăm să încărcați un fișier mai mic.',
    Warning: 'Avertisment',
    'You might loose some layout settings by this change. Do you wish to continue?':
      'Este posibil să pierdeți unele setări de aspect prin această modificare. Vrei sa continui?',
    'Bottom description': 'Descriere din jos',
    'Logo size': 'Dimensiunea logo-ului',
    Small: 'Mic',
    Medium: 'Mediu',
    Large: 'Mare',
    'Hviezda sladkov': 'The Brewers Star - BW',
    'Farebna hviezda sladkov': 'The Brewers Star - color',
  },
}
